<template lang="pug">
.res-info-card
  .top
    .date 2020年02月15日
    arrow-btn-blue(copy="即将开始" from="/me/res" to="/me/res")
  .bottom
    time-range(:fs1="30" :fs2="90")
  
</template>
<script>
import TimeRange from '@/components/wedgits/TimeRange'
import ArrowBtnBlue from '@/components/wedgits/ArrowBtnBlue'
export default {
  name: 'ResInfoCardL',
  components: { ArrowBtnBlue, TimeRange },
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.res-info-card
  background: #ffffff
  width: 100%
  height: 100%
  display: flex
  justify-content: space-between
  align-items: flex-start
  flex-direction: column
  color: #1677FF
  padding: pxToRem(40)
  box-shadow: 0 pxToRem(-1) pxToRem(10) 0 rgba(226,226,226,0.73)
  border-radius: pxToRem(16)
  .top
    width: 100%
    display: flex
    justify-content: space-between
    //align-items: flex-start
    flex-direction: row
    .date
      font-size: pxToRem(36)
      line-height: pxToRem(50)
      letter-spacing: pxToRem(0.8)
    .status
      font-size: pxToRem(30)
  .bottom
    width: 100%
</style>
